var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c(
        "div",
        {
          staticClass:
            "mb-5 mb-md-3 section-header d-md-flex justify-content-between"
        },
        [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", {
              style: "background-image: url(" + _vm.valueC.vettoreIcon + ")",
              attrs: { title: _vm.valueC.vettore }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "mr-1" }, [_vm._v("N° VOLO:")]),
            _c("b", [_vm._v(_vm._s(_vm.valueC.numero))]),
            _vm._v(" "),
            _c("span", { staticClass: "mx-1" }, [_vm._v("-")]),
            _vm._v(" "),
            _c("span", { staticClass: "mr-1" }, [_vm._v("CLASSE:")]),
            _c("b", [_vm._v(_vm._s(_vm.valueC.classe))])
          ]),
          _vm._v(" "),
          !_vm.isMobile
            ? _c("div", { staticClass: "section-selezionato d-flex" }, [
                !_vm.selected
                  ? _c(
                      "div",
                      {
                        staticClass: "position-relative",
                        staticStyle: { left: "-10px", top: "2px" }
                      },
                      [
                        _c(
                          "h4",
                          {
                            class:
                              _vm.value.prezzoVenditaDelta > 0
                                ? "more currency"
                                : "minus currency"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.value.prezzoVenditaDelta >= 0
                                  ? "+" + _vm.value.prezzoVenditaDelta
                                  : _vm.value.prezzoVenditaDelta
                              ) + " €"
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected
                  ? _c(
                      "h6",
                      {
                        staticClass:
                          "position-relative text-primary default-bold text-uppercase",
                        staticStyle: { top: "8px", right: "10px" }
                      },
                      [_vm._v("selezionato")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.selected
                  ? _c(
                      "button",
                      {
                        staticClass: "py-1 btn btn-primary mr-2",
                        on: { click: _vm.onSelect }
                      },
                      [_vm._v("seleziona")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "icon-circle-border-blue" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.onDetail }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../../../assets/images/svg/blue/icone_dettagli.svg"),
                          width: "16px"
                        }
                      })
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "section-partenza-arrivo d-flex justify-content-between"
        },
        [
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.valueC.partenza.citta))]),
            _vm._v(" "),
            !_vm.isMobile ? _c("span", [_vm._v("|")]) : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("span", [_vm._v(_vm._s(_vm.valueC.partenza.aereoporto))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.valueC.arrivo.citta))]),
            _vm._v(" "),
            !_vm.isMobile ? _c("span", [_vm._v("|")]) : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("span", [_vm._v(_vm._s(_vm.valueC.arrivo.aereoporto))])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section-volo d-flex justify-content-between" },
        [
          _c("div", { staticClass: "flight-arrow arrow-right" }, [
            _c("b", [
              _vm._v(
                _vm._s(_vm.valueC.ore) + "H " + _vm._s(_vm.valueC.minuti) + "'"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "line" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.numeroScali > 0
                  ? _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.numeroScali) +
                          " " +
                          _vm._s(_vm.numeroScali === 1 ? "SCALO" : "SCALI") +
                          "\n                "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isScaliSuDifferentiAereoporti
                  ? _c("AlertIcon", {
                      attrs: {
                        type: "danger",
                        placement: "right",
                        title:
                          "il trasferimento tra gli aereoporti non è compreso nel prezzo"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "d-flex" }, [
              _c("h2", { staticClass: "mr-1" }, [
                _vm._v(_vm._s(_vm.valueC.partenza.sigla))
              ]),
              _vm._v(" "),
              _c("h3", [_c("b", [_vm._v(_vm._s(_vm.valueC.partenza.orario))])])
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.valueC.partenza.data))])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "d-flex justify-content-end" }, [
              _c("h3", [_c("b", [_vm._v(_vm._s(_vm.valueC.arrivo.orario))])]),
              _vm._v(" "),
              _c("h2", { staticClass: "ml-1" }, [
                _vm._v(_vm._s(_vm.valueC.arrivo.sigla))
              ])
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.valueC.arrivo.data))])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "section-selezionato d-flex p-2 justify-content-between border-top mt-2"
            },
            [
              _vm.selected
                ? _c(
                    "h5",
                    {
                      staticClass:
                        "position-relative text-primary default-bold text-uppercase mr-2",
                      staticStyle: { top: "5px" }
                    },
                    [_vm._v("selezionato")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.selected
                ? _c("div", { staticClass: "d-flex" }, [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "py-1 btn btn-primary",
                          on: { click: _vm.onSelect }
                        },
                        [_vm._v("seleziona")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "position-relative",
                        staticStyle: { left: "10px", top: "2px" }
                      },
                      [
                        _c(
                          "h4",
                          {
                            class:
                              _vm.value.prezzoVenditaDelta > 0
                                ? "more currency"
                                : "minus currency"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.value.prezzoVenditaDelta >= 0
                                  ? "+" + _vm.value.prezzoVenditaDelta
                                  : _vm.value.prezzoVenditaDelta
                              ) + " €"
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "icon-circle-border-blue" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.onDetail }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../../assets/images/svg/blue/icone_dettagli.svg"),
                        width: "16px"
                      }
                    })
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(this.value.voli, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            class:
              "section-dettaglio-volo d-md-flex justify-content-between py-4 " +
              ((item.scali && item.scali.length) === 0 ? "with-scalo" : "")
          },
          [
            _c("div", { staticClass: "left mb-2" }, [
              _c("div", {
                style: "background-image: url(" + _vm.valueC.vettoreIcon + ")",
                attrs: { title: _vm.volo(item).vettore }
              }),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("N° VOLO:")]),
                _c("b", { staticClass: "ml-1" }, [
                  _vm._v(_vm._s(_vm.volo(item).numero))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("CLASSE:")]),
                _c("b", { staticClass: "ml-1" }, [
                  _vm._v(_vm._s(_vm.volo(item).classe))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("AEREO:")]),
                _c("b", { staticClass: "ml-1" }, [
                  _vm._v(_vm._s(_vm.volo(item).aereo))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("BAGAGLIO:")]),
                _c("b", { staticClass: "ml-1" }, [
                  _vm._v(_vm._s(_vm.volo(item).bagaglio))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("div", { staticClass: "departure d-flex" }, [
                  _c("div", { staticClass: "timeline start" }, [
                    _c("h5", [_vm._v(_vm._s(_vm.volo(item).partenza.orario))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-between" },
                    [
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.volo(item).partenza.aereoporto))
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "(" + _vm._s(_vm.volo(item).partenza.sigla) + ")"
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("-")]),
                        _vm._v(" "),
                        _c(
                          "b",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.volo(item).partenza.terminal,
                                expression: "volo(item).partenza.terminal"
                              }
                            ],
                            staticClass: "terminal mb-2"
                          },
                          [
                            _vm._v(
                              "Terminal: " +
                                _vm._s(_vm.volo(item).partenza.terminal)
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "nowrap" }, [
                          _vm._v(_vm._s(_vm.volo(item).partenza.data))
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.volo(item).scali, function(item2, index2) {
                  return _c(
                    "div",
                    {
                      key: index2,
                      staticClass: "departure d-flex scalo",
                      attrs: { value: _vm.scalo }
                    },
                    [
                      _c("div", { staticClass: "timeline" }, [
                        _c("h5", [_vm._v(_vm._s(_vm.scalo(item2).orario))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-100 d-flex justify-content-between" },
                        [
                          _c("div", [
                            _c("b", [
                              _vm._v(_vm._s(_vm.scalo(item2).aereoporto))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("(" + _vm._s(_vm.scalo(item2).sigla) + ")")
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("-")]),
                            _vm._v(" "),
                            _c(
                              "b",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.scalo(item2).terminal,
                                    expression: "scalo(item2).terminal"
                                  }
                                ],
                                staticClass: "terminal mb-2"
                              },
                              [
                                _vm._v(
                                  "Terminal: " +
                                    _vm._s(_vm.scalo(item2).terminal)
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "arrival d-flex" }, [
                  _c("div", { staticClass: "timeline end" }, [
                    _c("h5", [_vm._v(_vm._s(_vm.volo(item).arrivo.orario))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-between" },
                    [
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.volo(item).arrivo.aereoporto))
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "(" + _vm._s(_vm.volo(item).arrivo.sigla) + ")"
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("-")]),
                        _vm._v(" "),
                        _c(
                          "b",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.volo(item).arrivo.terminal,
                                expression: "volo(item).arrivo.terminal"
                              }
                            ],
                            staticClass: "terminal mb-2"
                          },
                          [
                            _vm._v(
                              "Terminal: " +
                                _vm._s(_vm.volo(item).arrivo.terminal)
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", { staticClass: "nowrap" }, [
                          _vm._v(_vm._s(_vm.volo(item).arrivo.data))
                        ])
                      ])
                    ]
                  )
                ])
              ],
              2
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04aeec52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04aeec52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/flight-panel/FlightSection.vue
// module id = null
// module chunks = 